import { render, staticRenderFns } from "./TextTruncator.vue?vue&type=template&id=3e153c65&scoped=true&"
import script from "./TextTruncator.vue?vue&type=script&lang=js&"
export * from "./TextTruncator.vue?vue&type=script&lang=js&"
import style0 from "./TextTruncator.vue?vue&type=style&index=0&id=3e153c65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e153c65",
  null
  
)

export default component.exports